/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error",
  { "props": true, "ignorePropertyModificationsFor": ["state"] }] */

import Vue from 'vue';
import Vuex from 'vuex';
// import state from '../../config/sanant-mortgage/state';
import state from './state.json';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    ...state,
    manual_required_check: {},
    vote_count: 0,
    submission: new FormData(),
  },
  mutations: {
    UPDATE_VOTE_COUNT(state, voteCount) {
      state.vote_count = voteCount;
    },
    CHANGE_EXPIRATION_DATE(state, newDate) {
      state.expiration_date = newDate;
    },
    REMOVE_LOGO(state) {
      state.publication_logo = null;
    },
    CHANGE_LOGO(state, uri) {
      state.publication_logo = uri;
    },
    REMOVE_WELCOME_TEXT(state) {
      state.welcome = null;
    },
    REMOVE_HEADER_TEXT(state) {
      state.survey_title = null;
    },
    REMOVE_SUBHEADER_TEXT(state) {
      state.survey_subtitle = null;
    },
    UPDATE_UUID(state, uuid) {
      state.uuid = uuid;
    },
    SET_NEW_SUBMISSION_FIELD(state, { name, value }) {
      state.submission.set(name, value);
    },
  },
  actions: {
    updateVoteCount({ commit }) {
      let voteCount = 0;
      [...document.querySelectorAll('.vote-field')].forEach((input) => {
        if (input.value !== '') {
          voteCount += 1;
        }
      });
      commit('UPDATE_VOTE_COUNT', voteCount);
    },
    resetVoteCount({ commit }) {
      commit('UPDATE_VOTE_COUNT', 0);
    },
    changeExpirationDate({ commit }, newDate) {
      commit('CHANGE_EXPIRATION_DATE', newDate);
    },
    changeLogo({ commit }, uri) {
      if (uri === null) {
        commit('REMOVE_LOGO');
      } else {
        commit('CHANGE_LOGO', uri);
      }
    },
    createUuid({ commit }) {
      /* https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript */
      let d = new Date().getTime();
      // If we can use performance, use it
      if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now();
      }
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0;  /* eslint-disable-line */
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16); /* eslint-disable-line */
      });
      commit('UPDATE_UUID', uuid);
    },
    addToSubmission({ commit }, field) {
      commit('SET_NEW_SUBMISSION_FIELD', field);
    },
  },
  getters: {
    fields: (state) => {
      // state.fields is leftover from when we created field layouts in code
      // The DJX admin interface builds state.layout.
      // At some point we can remove the state.fields if block.
      if (state.fields) {
        const orderedFields = {};
        Object.keys(state.fields).sort().forEach((key) => {
          orderedFields[key] = state.fields[key];
        });
        return orderedFields;
      }
      return state.layout;
    },
    categories: state => Object.keys(state.categories)
      .filter(header => header !== 'ADS')
      .reduce((obj, header) => {
        /* eslint-disable-next-line no-param-reassign */
        obj[header] = state.categories[header];
        return obj;
      }, {}),
    title: state => state.survey_title,
  },
});
